import { useEffect, useState } from 'react';

import Loader from '~components/generic/loader/Loader';
import { PageLayout } from '~components/page/PageLayout';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import usePermissions from '~hooks/usePermissions';
import { selectAddonsMyFiles } from '~store/selectors';

export default function MyFilesPage() {
  const myFiles = useAppSelector(selectAddonsMyFiles);
  const { hlMyFiles } = useLabels(['hlMyFiles']);
  const { hasViewMyFilesPermission } = usePermissions();
  const navigateToDefault = useNavigateToDefault();
  const [iframeUrl, setIframeUrl] = useState('');
  const [loadingIframe, setLoadingIframe] = useState(true);

  useEffect(() => {
    if (!myFiles.cloudBasePath) {
      navigateToDefault();
    }
  }, [myFiles, navigateToDefault]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const baseUrl = `${myFiles.cloudUrl}${myFiles.cloudBasePath}`;

    let params = Array.from(queryParams)
      .filter(([key]) => myFiles.cloudQueryVars.includes(key))
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');

    const newIframeUrl = `${baseUrl}?${params}`;
    setIframeUrl(newIframeUrl);
  }, [myFiles.cloudBasePath, myFiles.cloudUrl, myFiles.cloudQueryVars]); // Runs once on mount

  return (
    <PageLayout title={hlMyFiles} className="page--myfiles">
      {hasViewMyFilesPermission ? (
        <div className="u-padding-horizontal-xxl">
          <div className="c-view__header u-margin-bottom-md">
            <div className="o-grid o-grid--unpad o-grid--bottom">
              <div className="o-grid__cell o-grid__cell--width-10">
                <h2>{myFiles.headlineText}</h2>
                <p dangerouslySetInnerHTML={{ __html: myFiles.messageText }} />
              </div>
            </div>
          </div>
          <div className="c-view__content">
            <article className="row no-gutters">
              <section className="col col-12 d-flex iframe-container ">
                <iframe
                  src={iframeUrl}
                  width="100%"
                  title={'MyFiles'}
                  height={800}
                  allow={'clipboard-read; clipboard-write'}
                  onLoad={() => setLoadingIframe(false)}
                ></iframe>
                {loadingIframe ? <Loader absoluteCenter={true} /> : null}
              </section>
            </article>
          </div>
        </div>
      ) : (
        <div className="u-padding-horizontal-xxl">
          <div className="c-view__header u-margin-bottom-md">
            <div className="o-grid o-grid--unpad o-grid--bottom">
              <div className="o-grid__cell o-grid__cell--width-10">
                <h2>{myFiles.headlineTextForbidden}</h2>
                <p dangerouslySetInnerHTML={{ __html: myFiles.forbiddenText }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
}
